var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-49d7a881-bee1-4cf1-a877-73380175305d",
    "data-name": "uuid-3d5d3554-b5da-455d-b7f6-0c569f5abbf4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1506.89 866.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-5ee3d677-852d-477a-b0c3-815e4704f667 {\n        fill: #b46226;\n      }\n\n      .uuid-c1f97315-fc2a-4f20-bc30-2beda321af80 {\n        fill: #fff;\n      }\n\n      .uuid-bc95c6c9-2f22-4741-8ca2-26b234659f59 {\n        fill: #ff919a;\n      }\n\n      .uuid-e9ad4538-9a0d-4e84-8212-bd02dbfdb013 {\n        fill: #70d4ff;\n      }\n\n      .uuid-66f2c2d5-b193-4c3c-be7a-5c98cfc8060e {\n        fill: #bcebff;\n      }\n\n      .uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9 {\n        fill: #ffac9c;\n      }\n\n      .uuid-d2f86466-a479-42fb-81cb-eeafb362b770 {\n        fill: #2743ab;\n      }\n\n      .uuid-21d8dcf6-c4ef-4b67-adb7-97569fdae9bb {\n        fill: #27a0cc;\n        fill-rule: evenodd;\n      }\n\n      .uuid-8aa66b01-1d3f-4c62-8c8b-8062239e0ac0 {\n        fill: #ffd600;\n      }\n\n      .uuid-436c2d48-4f0d-4060-a52d-7435098e607f {\n        fill: #823c26;\n      }\n\n      .uuid-d4b2fc3e-309f-4a28-a14c-746fe3c56a89 {\n        fill: #0c3240;\n      }\n\n      .uuid-b0a15bf1-8efb-4842-8314-a0db4c768530 {\n        fill: #000e1b;\n      }\n\n      .uuid-cecafedd-d959-4d60-b30c-9fd13d7ee6a9, .uuid-0f95db09-a7fd-49bd-8d59-0c5135a1e3b8 {\n        fill: none;\n      }\n\n      .uuid-0f95db09-a7fd-49bd-8d59-0c5135a1e3b8 {\n        stroke: #0c3240;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 11px;\n      }\n\n      .uuid-ed05a5a5-f5ab-4b71-8935-7a6a033f67ae {\n        fill: #1a7dfb;\n      }\n\n      .uuid-c89a0f33-fd43-48dd-abc0-947599c8fadf {\n        fill: #e5f3ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-21d8dcf6-c4ef-4b67-adb7-97569fdae9bb",
    d: "m1026.14,724.46c62.6-101.1,241,70.6,389.6,56.5s18.6-159.4,54.4-243.5c58.4-137.3,75.1-509.8-166.5-515.6-241.6-5.9-306.4,209.1-482,203.1-175.5-6-381.9-183-598.6-108.8C6.34,190.46,57.24,523.96,367.94,604.66c257.2,66.7,203.6,171.7,322.3,232,118.6,60.2,246,32.9,335.9-112.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-21d8dcf6-c4ef-4b67-adb7-97569fdae9bb",
    d: "m151.34,110.96c6,12.3,110.9-21.8,177.5-24,66.6-2.3-12.9-106.2-84.8-83.8-71.8,22.4-101,90.6-92.7,107.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-21d8dcf6-c4ef-4b67-adb7-97569fdae9bb",
    d: "m1056.24,61.46c-13.5-54.6,28.6-68,63.3-55.5,34.6,12.5-12.7,31.6-30.6,48.5-18,16.9-31.3,12.8-32.7,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-21d8dcf6-c4ef-4b67-adb7-97569fdae9bb",
    d: "m90.54,500.26C60.24,479.96-1.76,485.16.04,519.66c1.9,34.5,86.7,47.1,108,36.1,21.4-10.9-2.1-45.2-17.5-55.5h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    x: 948.71,
    y: 185.38,
    width: 100.5,
    height: 44.5,
    transform: "translate(188.57 827.55) rotate(-49.16)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-d4b2fc3e-309f-4a28-a14c-746fe3c56a89",
    points: "1017.84 240.46 1058.24 187.26 1015.04 155.06 972.84 203.96 1017.84 240.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d4b2fc3e-309f-4a28-a14c-746fe3c56a89",
    d: "m1017.34,186.46c9.3,8,23.3,7,31.4-2.3,8-9.3,7-23.3-2.3-31.4-9.3-8-23.3-7-31.4,2.3-8,9.3-7,23.4,2.3,31.4h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    d: "m1042.74,748.06c-10-1.3-17.6-11.2-17.6-11.2h-9.4c3.2-16.3,2.7-21.3,2.7-21.3l41.3,13.5-.5,8.7h0c-3.2-.2-6.3,1.8-7.4,4.8-1.2,3-3.7,6.2-9.1,5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e9ad4538-9a0d-4e84-8212-bd02dbfdb013",
    d: "m980.14,760.06c11.5-6.3,31.5-3.5,35.2-21.3.1-.7.3-1.2.4-1.9h9.4s7.7,10,17.6,11.2c5.4.7,7.9-2.5,9-5.6,1.1-3,4.1-5,7.4-4.8h0l-2.1,34.5h-89.7s1.3-5.8,12.8-12.1h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-66f2c2d5-b193-4c3c-be7a-5c98cfc8060e",
    d: "m1041.54,757.56c4.8-3.7,10.7-5.9,16.7-6.3l-.1,2.3c-5.5.4-10.8,2.4-15.1,5.8-4.2,3.3-7.4,7.8-9.1,12.8h-2.4c1.7-5.7,5.3-10.9,10-14.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-66f2c2d5-b193-4c3c-be7a-5c98cfc8060e",
    d: "m1025.04,736.86s.3.4.9,1.1c-2.3,11.9-8.2,19.6-18.1,23.6-2.2.9-4.4,1.3-6.7,1.3-5,0-9.8-2.1-13.3-5.7.8-.2,1.7-.5,2.5-.7,4.5,4,10.9,5.3,16.6,3,9.3-3.7,14.8-11.1,16.8-22.5l1.3-.1h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    points: "1056.94 772.16 1056.44 779.06 966.74 779.06 967.34 772.16 1056.94 772.16"
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    d: "m1217.14,740.66l-8.5-16.8-36.6,8.3,2.5,10.3s7.7,4.6,24.1,5.5c16.5,1,18.5-7.3,18.5-7.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e9ad4538-9a0d-4e84-8212-bd02dbfdb013",
    d: "m1210.84,740.76s-6.6-4.7-15.1-4.3c-8.5.3-12.8,6.2-12.8,6.2h-8.3l8.6,29.5h48.9l-14.9-31.4h-6.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    points: "1232.04 772.16 1235.54 779.06 1184.94 779.06 1183.14 772.16 1232.04 772.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-66f2c2d5-b193-4c3c-be7a-5c98cfc8060e",
    d: "m1230.64,771.76l-.3.3h-2.9c-6.2-4.9-14.6-7.6-22.9-7.1-7,.4-13.8,3-19.1,7.1h-2.3l-.2-.8c5.8-5,13.5-8.1,21.5-8.6,9.6-.4,19.4,2.9,26.2,9.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-66f2c2d5-b193-4c3c-be7a-5c98cfc8060e",
    d: "m1182.94,742.66s.1-.2.4-.5c1.4,4.2,6.8,18.3,19.1,18.3h.4c3.3-.1,5.7-1.2,7.3-3.3,3.4-4.7,1.7-13.2,1-16.3h2.3c.9,3.8,2.3,12.4-1.5,17.6-2,2.7-5,4.2-9,4.3h-.5c-13.9,0-19.9-15.7-21.3-20.1h1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1084.54,306.86s11,15.2,6.8,74.5c-1.8,25.2-13.6,107-16.5,158.2l-59.1-3.7,10.9-213.3,57.9-15.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    points: "1074.74 539.46 1062.14 731.16 1011.14 731.16 1015.74 535.76 1074.74 539.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1015.74,535.76c-1,16.3,11.4,30.4,27.7,31.4s30.4-11.4,31.4-27.7-11.4-30.4-27.7-31.4c-16.3-1-30.4,11.4-31.4,27.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1015.74,535.76c-1,16.3,11.4,30.4,27.7,31.4s30.4-11.4,31.4-27.7-11.4-30.4-27.7-31.4c-16.3-1-30.4,11.4-31.4,27.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    points: "1182.64 534.26 1219.34 722.76 1170.04 735.86 1124.54 545.76 1182.64 534.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1124.54,545.76c3.2,16,18.7,26.5,34.8,23.3,16-3.2,26.5-18.7,23.3-34.8-3.2-16-18.7-26.5-34.8-23.3-16,3.2-26.5,18.7-23.3,34.8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1132.94,321.56s12.4,12.9,23.5,67.2c5.1,24.8,15.9,95.2,26.2,145.5l-58.1,11.5-54-225.1,62.4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1124.54,545.76c3.2,16,18.7,26.5,34.8,23.3,16-3.2,26.5-18.7,23.3-34.8-3.2-16-18.7-26.5-34.8-23.3-16,3.2-26.5,18.7-23.3,34.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-cecafedd-d959-4d60-b30c-9fd13d7ee6a9",
    d: "m1140.14,238.86l.1.1-.2.4c.1-.3.1-.5.1-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d4b2fc3e-309f-4a28-a14c-746fe3c56a89",
    d: "m1132.94,321.56l11.8-117.4-8.2-56.9h-104.6s-26,51.1-5.7,116.2l.4,58.8,106.3-.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    points: "1099.24 99.36 1097.44 145.76 1058.74 145.76 1061.64 127.36 1099.24 99.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1063.84,131.26c-1.1.1-2,.1-2.8,0l-1.2,7.4c18.8-1.2,24.9-20.5,24.9-20.5h0c-4.2,4.7-15.9,12.6-20.9,13.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m1091.04,105.36s-2.4,8.5-5.3,12.9c-2.8,4.2-20,18.2-29.4,12-7.1-4.7-8.6-16.6-8.9-24.9-.4-9.6-.6-20.6.8-29.3l32.2-6.4,11.9,26.3-1.3,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1058.64,95.86c0,1.9-1.1,3.5-2.4,3.5s-2.4-1.6-2.4-3.5,1.1-3.5,2.4-3.5,2.4,1.6,2.4,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1072.44,95.26c0,1.9-1.1,3.5-2.4,3.5s-2.4-1.6-2.4-3.5,1.1-3.5,2.4-3.5,2.4,1.6,2.4,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1052.34,85.36c-.3,0-.5-.1-.7-.4-.2-.4-.1-.9.2-1.1,2.1-1.3,4.7-1.4,6.9-.2.4.2.5.7.3,1.1s-.7.5-1.1.3c-1.7-.9-3.7-.9-5.3.1,0,.1-.1.2-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1065.34,85.66c-.2,0-.5-.1-.6-.3-.3-.4-.2-.9.2-1.1,2.2-1.6,5.4-1.8,7.8-.3.4.2.5.7.3,1.1s-.7.5-1.1.3c-1.8-1.1-4.3-1-6,.2-.3,0-.4.1-.6.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1060.54,115.66h-.8c-.4,0-.8-.4-.7-.9,0-.4.4-.8.9-.7,3.2.4,6.4-1.9,7.5-5.3.1-.4.6-.6,1-.5s.6.6.5,1c-1.2,3.8-4.7,6.4-8.4,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1060.14,109.36c-.5,0-1.3-.1-1.9-.6-.5-.4-.9-1-1-1.7-.3-2,2.4-12,3-14,.1-.4.6-.7,1-.6s.7.6.6,1c-1.2,4.5-3.1,12.1-2.9,13.4.1.4.2.5.3.6.4.3,1.1.3,1.3.2.4-.1.8.2.9.7.1.4-.2.8-.7.9,0,.1-.2.1-.6.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m1099.24,70.66s21.5-6.5,1.4,29.4l-2.1,17.3-7.1-9.9-4.9-8.9-3.2,8.2h-1.8l.5-19.6s-7.1-2.4-6.7-11.7c0,0-31.7,9.2-36.5-1.9l5.6-7.9,3.9,2.1s-5.2-5.2-5.6-13.3l7.4,6.5s-5.3-6.7,0-15.3l9.4-.4s2.3,4.9,10.2,8.4c9.4,4.1,34.4.4,29.5,17h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    cx: 1093.84,
    cy: 101.26,
    r: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    d: "m1074.94,162.96l-8.3-15.5-10,14.7s-3.2-11.7-3.2-14.8l7.1-12.3,6.4,8.9,31.3-14.1,2.6,17.6-25.9,15.5h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m1190.14,227.66c-11.1,5.3-15.7,18.6-10.4,29.7,5.3,11.1,18.6,15.7,29.7,10.4,11.1-5.3,15.7-18.6,10.4-29.7s-18.6-15.8-29.7-10.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    points: "1217.14 233.66 1181.84 190.16 1159.94 233.76 1182.54 261.66 1217.14 233.66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-d4b2fc3e-309f-4a28-a14c-746fe3c56a89",
    points: "1203.74 195.86 1149.94 151.86 1119.24 183.66 1159.94 233.76 1203.74 195.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d4b2fc3e-309f-4a28-a14c-746fe3c56a89",
    d: "m1150.54,186.96c9.5-7.7,11-21.8,3.3-31.3s-21.8-11-31.3-3.3-11,21.8-3.3,31.3c7.7,9.5,21.7,11,31.3,3.3h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    points: "1182.94 233.16 1123.54 311.56 1148.14 332.66 1216.74 262.16 1182.94 233.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m1214.34,230.76c-9.3-8-23.4-6.9-31.4,2.4-8,9.3-6.9,23.4,2.4,31.4s23.4,6.9,31.4-2.4c8-9.3,6.9-23.4-2.4-31.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m1146.44,309.86c-6.8-5.8-17-5.1-22.9,1.7-5.8,6.8-5.1,17,1.7,22.9,6.8,5.8,17,5.1,22.9-1.7,5.8-6.9,5.1-17.1-1.7-22.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m1123.54,311.56c-9.6,5.3-28.5,22.6-27.4,25.2s19.8-9,19.8-9l7.6-16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m1123.54,311.56c-13.5,13.4-33.7,45.8-32.1,48.4,1.7,2.5,18.2-17.5,18.2-17.5,0,0-13.6,19.6-10.5,22.7s15.6-18.7,15.6-18.7c0,0-9.9,24-6.8,25.1s12.2-22.6,12.2-22.6c0,0-3.8,21.9-.8,22.1s6-17.7,7.3-21.3c1.3-3.6,13.2-.8,21.5-17.1l-24.6-21.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m1149.64,313.66c4.7,7.7,2.2,17.6-5.4,22.3-7.7,4.7-17.6,2.2-22.3-5.4-4.7-7.7-2.2-17.6,5.4-22.3,7.7-4.6,17.7-2.2,22.3,5.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    points: "981.54 229.56 910.14 165.46 887.34 187.76 950.24 261.26 981.54 229.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m981.74,261.56c8.8-8.6,9-22.7.4-31.5s-22.7-8.9-31.5-.4c-8.8,8.6-9,22.7-.4,31.5,8.6,8.8,22.7,9,31.5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m908.84,187.06c6.4-6.3,6.5-16.5.3-22.9-6.3-6.4-16.5-6.5-22.9-.3-6.4,6.3-6.5,16.5-.3,22.9,6.3,6.4,16.5,6.5,22.9.3h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m904.74,189.96c-8,4-17.8.7-21.7-7.3s-.7-17.8,7.3-21.7c8-4,17.8-.7,21.7,7.3,4,8,.7,17.7-7.3,21.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m890.14,189.86c-8-4.1-11.1-13.8-7.1-21.8s13.8-11.1,21.8-7.1c8,4.1,11.1,13.8,7.1,21.8-4,8-13.8,11.2-21.8,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m908.74,151.06c-5.1-6.9-17-10.7-17-10.7,0,0-22.3-9-31.3-7.3-6.6,1.2,7.4,6.5,12,8.4-6.3.7-18.1,0-18.4,1.6-.9,4.1,21.3,5.3,21.3,5.3,0,0-20.7,1.1-20.4,3.7.3,2.6,21.4,3.1,21.4,3.1,0,0-18.6,1.7-17.4,4.3,1.2,2.6,25.3-.9,24,2.7-4.2,11.1,2,18.7,2,18.7l13.8-2.3,10-27.5h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m851.04,172.56l-31.9-70.1c-1.8-4,0-8.6,3.9-10.4l40-18.1c4-1.8,8.6,0,10.4,3.9l31.9,70.1c1.8,4,0,8.6-3.9,10.4l-40,18.1c-3.9,1.8-8.6.1-10.4-3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ed05a5a5-f5ab-4b71-8935-7a6a033f67ae",
    d: "m830.94,92.06l-6.5,2.9c-2.3,1.1-3.4,3.8-2.3,6.1l30.9,67.8c1.1,2.3,3.8,3.4,6.1,2.3l40-18.1c2.3-1.1,3.4-3.8,2.3-6.1l-30.9-67.8c-1.1-2.3-3.8-3.4-6.1-2.3l-6.5,2.9-27,12.3h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m914.64,176.66s3-21.7.1-28.2c-5-11.4-21-11.8-23.1-8.1s11,6.2,11.7,10c1.5,7.5-15.8,16.5-9.8,29.1l21.1-2.8h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    points: "444.14 357.66 336.94 357.66 392.14 533.66 464.84 533.66 497.54 533.66 444.14 357.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    points: "380.34 558.56 357.04 772.06 364.44 772.06 397.94 560.06 380.34 558.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    points: "481.84 558.56 505.24 772.06 497.84 772.06 464.34 560.06 481.84 558.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    points: "564.44 558.56 587.84 772.06 580.44 772.06 546.94 560.06 564.44 558.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m567.94,533.66h-103.1l6.6,27.8c.6,2.7,3.1,4.6,3.5,4.6h102.8l-9.8-32.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-8aa66b01-1d3f-4c62-8c8b-8062239e0ac0",
    d: "m485.64,533.66h-93.6l-55.2-176-8.8-.5,37.8,204.4c.6,2.7,3.1,4.6,5.8,4.6h121.4l-7.4-32.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-436c2d48-4f0d-4060-a52d-7435098e607f",
    d: "m411.84,508.46s21.7,24,80.4,24.8c25,.3,104.6-9,155.2-7.5l1.9-66.7-149.4-5.1-67.9-1.1-20.2,55.6h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-436c2d48-4f0d-4060-a52d-7435098e607f",
    cx: 648.34,
    cy: 492.36,
    r: 33.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m573.94,682.46s-1.5,20.9-1.6,25.1c-.2,4.2,28.4,28.5,24.4,35.9l-48.3-25.9-12.7-21.6-12.3,8.4-5.8-3.1s18.2-26.9,29-39.3l27.3,20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m665.74,718.36s14.1,15.5,17.1,18.5c2.9,3,40.2-.9,42.8,7.1l-52.1,17-24.3-5.7-2.4,14.7-6.2,2s-7-31.7-8.5-48.1l33.6-5.5h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-436c2d48-4f0d-4060-a52d-7435098e607f",
    points: "618.34 477.96 524.24 673.86 585.14 703.06 678.44 506.86 618.34 477.96"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-436c2d48-4f0d-4060-a52d-7435098e607f",
    cx: 648.31,
    cy: 492.47,
    r: 33.3,
    transform: "translate(141.11 1129.33) rotate(-88.69)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5ee3d677-852d-477a-b0c3-815e4704f667",
    d: "m406.54,465.66s-5.9,28.4,5,50.9c17.3,35.6,157.7,10.9,207.1,21.6l14.1-65.2-132.7-19-40-5.7-53.5,17.4h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-5ee3d677-852d-477a-b0c3-815e4704f667",
    cx: 625.64,
    cy: 505.56,
    r: 33.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-5ee3d677-852d-477a-b0c3-815e4704f667",
    points: "592.64 510.06 622.04 725.36 689.04 716.16 658.74 501.06 592.64 510.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5ee3d677-852d-477a-b0c3-815e4704f667",
    d: "m658.74,501.06c2.5,18.2-10.3,35.1-28.5,37.6s-35.1-10.3-37.6-28.5,10.3-35.1,28.5-37.6c18.3-2.6,35.1,10.2,37.6,28.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c89a0f33-fd43-48dd-abc0-947599c8fadf",
    d: "m481.74,357.66c-10.8,5.6-24,1.4-29.6-9.4s-1.4-24,9.4-29.6,24-1.4,29.6,9.4,1.4,24-9.4,29.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m527.44,445.76c-10.8,5.6-24,1.4-29.6-9.4s-1.4-24,9.4-29.6,24-1.4,29.6,9.4c5.6,10.7,1.4,24-9.4,29.6h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-c89a0f33-fd43-48dd-abc0-947599c8fadf",
    x: 472.59,
    y: 332.67,
    width: 43.9,
    height: 99.2,
    transform: "translate(-120.53 270.94) rotate(-27.44)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m527.44,445.76c-10.8,5.6-24,1.4-29.6-9.4s-1.4-24,9.4-29.6,24-1.4,29.6,9.4c5.6,10.7,1.4,24-9.4,29.6h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-c89a0f33-fd43-48dd-abc0-947599c8fadf",
    x: 472.59,
    y: 332.67,
    width: 43.9,
    height: 99.2,
    transform: "translate(-120.53 270.94) rotate(-27.44)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c89a0f33-fd43-48dd-abc0-947599c8fadf",
    points: "468.94 409.36 450.34 343.36 491.14 328.06 520.54 384.66 468.94 409.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c89a0f33-fd43-48dd-abc0-947599c8fadf",
    d: "m481.74,357.66c-10.8,5.6-24,1.4-29.6-9.4s-1.4-24,9.4-29.6,24-1.4,29.6,9.4,1.4,24-9.4,29.6h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    points: "496.94 418.26 537.64 330.16 567.54 341.76 537.84 434.16 496.94 418.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m509.34,446.66c-11.3-4.4-16.9-17.1-12.5-28.4s17.1-16.9,28.4-12.5,16.9,17.1,12.5,28.4c-4.3,11.3-17.1,16.9-28.4,12.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m546.74,350.86c-8.2-3.2-12.3-12.5-9.1-20.7s12.5-12.3,20.7-9.1c8.2,3.2,12.3,12.5,9.1,20.7-3.2,8.3-12.4,12.3-20.7,9.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c89a0f33-fd43-48dd-abc0-947599c8fadf",
    d: "m471.84,316.26h-64.8l-13.1,100.2c-1,7.6,4.9,14.3,12.6,14.3h93.4c6.9,0,11.7-6.9,9.3-13.4l-37.4-101.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-c89a0f33-fd43-48dd-abc0-947599c8fadf",
    x: 406.54,
    y: 430.76,
    width: 93.4,
    height: 23.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m386.94,457.66c-12-2-20-13.4-18-25.3,2-12,13.4-20,25.3-18,12,2,20,13.4,18,25.3s-13.4,20-25.3,18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m386.94,457.66c-12-2-20-13.4-18-25.3,2-12,13.4-20,25.3-18,12,2,20,13.4,18,25.3s-13.4,20-25.3,18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    points: "368.94 432.36 375.04 395.96 418.14 404.66 412.24 439.66 368.94 432.36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    points: "362.04 393.36 386.94 329.46 428.74 341.86 418.14 404.66 362.04 393.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    d: "m403.44,359.86c-12-2-20-13.4-18-25.3s13.4-20,25.3-18c12,2,20,13.4,18,25.3s-13.3,20-25.3,18Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    points: "404.14 418.66 476.74 483.06 457.04 508.26 377.04 453.26 404.14 418.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m373.24,422.46c7.5-9.6,21.3-11.2,30.8-3.8,9.6,7.5,11.2,21.3,3.8,30.8s-21.3,11.2-30.8,3.8-11.2-21.2-3.8-30.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m454.34,485.86c5.4-7,15.5-8.2,22.5-2.7,7,5.4,8.2,15.5,2.8,22.5-5.4,7-15.5,8.2-22.5,2.8-7.1-5.6-8.3-15.7-2.8-22.6h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m496.64,499.46c8.4,16.9,12.7,37.6,9.9,37.9-4.2.5-9.9-21.1-9.9-21.1,0,0,4.4,21.6.7,23.1-4.2,1.7-7.9-20.8-7.9-20.8,0,0,1.8,22.5-2.1,22.5-3.4,0-3.7-21.3-3.7-21.3,0,0-3.7,18.3-6.6,17.8s0-14.9-1-18.5-10.4-1.9-18.1-10.3l15.4-27.9c10.8,3,18.6,9.1,23.3,18.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m451.14,493.06c-1.5,8.7,4.4,17,13.2,18.4,8.7,1.5,17-4.4,18.4-13.2,1.5-8.7-4.4-17-13.2-18.4-8.7-1.4-17,4.5-18.4,13.2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m426.14,241.06c-23.5,4.2-24.5,20.3-19.8,34.7,4.8,14.4-5,18.7-6.1,25.6s8.7,9.1,8.7,9.1c0,0-5.1-3.6-2.6-6.3,5-5.2,11.4,4.3,22.4,4.1,11-.2-.3-52.4-.3-52.4l-2.3-14.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m446.84,242.96c13.9-1,23.1-7.3,26.7.1,5,10.2,2.6,22.6,2.2,28.9-1,15.1,8.3,16.6,11,23,2.8,6.4-6.1,10.9-6.1,10.9,0,0,4.1-4.8,1-6.7-6.1-3.8-13.6,7.8-24.2,10.7-21.1,5.7-9.2-52.1-9.2-52.1l-1.4-14.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m429.84,230.76c0,10.3-8.4,18.7-18.7,18.7s-18.7-8.4-18.7-18.7,8.4-18.7,18.7-18.7,18.7,8.4,18.7,18.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m461.64,239.46l-19.7,4.9c-12.1,3-19.7,15-17.3,27.2l5.7,29,17.3,14.9,7.3-11.3c8.4-1,19.9-11.3,17-33.1-1.2-9.3-4.4-22.4-8.3-30.6-.2-.9-1.1-1.3-2-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m455.04,304.06c-6,.9-16.8-2.6-16.8-2.6,0,0,5.4,7.1,19.3,8.4l-2.5-5.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-bc95c6c9-2f22-4741-8ca2-26b234659f59",
    d: "m472.34,274.06c.3,4.7,0,8.8-.9,12.4-1.8-1.3-3-3.5-3-5.9,0-2.8,1.6-5.2,3.9-6.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-bc95c6c9-2f22-4741-8ca2-26b234659f59",
    d: "m434.64,279.86c0,4.1,3.3,7.4,7.4,7.4s7.4-3.3,7.4-7.4-3.3-7.4-7.4-7.4-7.4,3.4-7.4,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m461.54,279.86c-.4,0-.7-.3-.8-.6-.1-.4.2-.9.6-.9.7-.1,1.2-.7,1.4-1.3.2-.6-.1-1.4-.5-1.9-.2-.2-.5-.4-.8-.5-.3-.2-.6-.3-.8-.5-1.1-.8-1.8-2.2-1.7-3.5,0-.4.4-.8.8-.8s.8.4.8.8c0,.9.4,1.7,1.1,2.2.2.2.4.3.7.4.4.2.7.4,1.1.7.9.9,1.3,2.2,1,3.5-.3,1.2-1.4,2.2-2.6,2.5-.2-.1-.3-.1-.3-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m462.84,267.76c.3,1.7,1.5,2.9,2.6,2.7,1.2-.2,1.9-1.7,1.6-3.4-.3-1.7-1.5-2.9-2.6-2.7-1.2.2-1.9,1.7-1.6,3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m450.54,269.16c.3,1.7,1.5,2.9,2.6,2.7,1.2-.2,1.9-1.7,1.6-3.4-.3-1.7-1.5-2.9-2.6-2.7-1.2.2-1.9,1.7-1.6,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m459.94,258.66c-.2,0-.5-.1-.6-.3-.3-.4-.2-.9.1-1.1,1.8-1.4,4.2-1.7,6.2-.8.4.2.6.6.4,1s-.6.6-1,.4c-1.5-.6-3.3-.4-4.6.6-.1.1-.3.2-.5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m447.84,260.66c-.2,0-.5-.1-.6-.3-.3-.3-.2-.8.1-1.1,1.9-1.6,4.8-2,7-.8.4.2.5.7.3,1.1s-.7.6-1.1.3c-1.7-.9-3.8-.6-5.3.6,0,.2-.2.2-.4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m460.94,285.86c-3.6,0-7.3-2-9.1-5.1-.2-.4-.1-.9.3-1.1s.9-.1,1.1.3c1.8,3.2,5.9,5,9.5,4.1.4-.1.9.2,1,.6s-.2.9-.6,1c-.7.2-1.4.2-2.2.2h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    points: "455.04 304.06 447.74 314.66 430.44 300.56 426.14 316.26 441.94 328.36 448.34 317.56 457.24 326.66 461.04 316.26 455.04 304.06"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    cx: 422.24,
    cy: 276.26,
    r: 6.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m424.24,270.36s5.8,9.9,6.8,14.6c0,0,1.7-7.8-1.3-16.1,0,0,10-7.7,8.9-18.2-1.1-10.5-15.8-7-15.8-7,0,0-5.6,20.7,1.4,26.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d2f86466-a479-42fb-81cb-eeafb362b770",
    d: "m418.94,213.86c-3.2,3.3-7.2,5.9-11.6,7.4-4.1,1.4-8.6,1.7-12.9,1.2-.3.5-.5,1.1-.7,1.6,5.4,1.4,11.2,1.3,16.4-.5,4.6-1.5,8.7-4.3,12-7.8-.9-.7-2-1.4-3.2-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m470.44,238.36c-10.3-11.6-39.9-20.2-50.5,8.9l7.6,10.5s7.8-1.7,18.4-3.4c1.4-3.1,2.3-6.5,2.5-9.9.5,3.2.5,6.3.1,9.5,6-.9,12.6-1.8,19.2-2.4,6.7-.6,9-6.1,2.7-13.2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m546.74,305.86s-17.1-3.4-18.7-5.8c-3.4-5,12.7-6.8,12.7-6.8l6,12.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    d: "m527.44,335.16l15-65.7c.1-.4.4-.6.8-.5l6.4,1.5c.4.1.6.4.5.8l-15,65.7c-.1.4-.4.6-.8.5l-6.4-1.5c-.3-.1-.6-.4-.5-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m545.54,341.06l22.6-8.4s1.6-8.9-1.3-22.9c-2.9-14-16.8-24.1-16.8-24.1-9.8-6.6-11.2-6.1-11.9-4.3-.7,1.7.7,5.5,7.1,10.5,0,0-8.8-4.8-9.7-1.7-.9,3.1,7.9,11.6,7.9,11.6,0,0-9.7-5.3-10.4-1.7-.6,3.1,5.8,11.7,5.8,11.7,0,0-8.7-6.1-10-3.5-1.7,3.5,8.8,16.2,8.8,16.2l7.9,16.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m563.74,342.56c6.2-6.4,6-16.5-.4-22.6-6.3-6.2-16.5-6-22.6.4-6.2,6.4-6,16.5.4,22.6,6.3,6.1,16.4,5.9,22.6-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5a61d327-37e5-40a8-9ac8-faa1e1aec4f9",
    d: "m533.24,316.26s-3.1,10.1,5.2,15.3c8.4,5.2,11.5-2.7,11.5-2.7l-16.7-12.6h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    points: "888.94 427.16 921.84 772.06 913.54 772.06 871.64 430.16 888.94 427.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    points: "495.84 427.16 462.84 772.06 471.14 772.06 513.14 430.16 495.84 427.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-8aa66b01-1d3f-4c62-8c8b-8062239e0ac0",
    x: 471.44,
    y: 420.16,
    width: 442,
    height: 12.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    d: "m849.84,399.16h-159.4c-1.7,0-2.9-1.5-2.7-3.1l15.5-101.7c.3-2.3,2.4-4.1,4.7-4.1h157.9c2.3,0,3.8,1.8,3.5,4.1l-15.4,101.4c-.4,1.9-2.1,3.4-4.1,3.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-b0a15bf1-8efb-4842-8314-a0db4c768530",
    points: "756.54 380.66 753.14 399.26 765.14 399.26 756.54 380.66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    d: "m801.64,420.16h-34.2l-10.9-39.4h39.5l9.5,34.3c.7,2.5-1.3,5.1-3.9,5.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-c1f97315-fc2a-4f20-bc30-2beda321af80",
    x: 741.34,
    y: 416.86,
    width: 33.2,
    height: 3.3
  }))))), /*#__PURE__*/React.createElement("line", {
    className: "uuid-0f95db09-a7fd-49bd-8d59-0c5135a1e3b8",
    x1: 235.34,
    y1: 776.56,
    x2: 1408.34,
    y2: 776.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-0f95db09-a7fd-49bd-8d59-0c5135a1e3b8",
    x1: 1438.34,
    y1: 776.56,
    x2: 1482.34,
    y2: 776.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-0f95db09-a7fd-49bd-8d59-0c5135a1e3b8",
    x1: 219.34,
    y1: 776.56,
    x2: 204.34,
    y2: 776.56
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/Main.a9a65d95c5f9ce1aa28d0b09a87a9908.svg";
export { ForwardRef as ReactComponent };